module.exports = __webpack_public_path__ + "img/CPQ-ability-02.fb3442e4.png";